import { useEffect, useLayoutEffect } from "react"
import useInput from "../../../hooks/useInput"
import InputMessage from "../../ui/inputError";
import InputLabel from "../../ui/inputLabel";
import { strings } from "../../../assets/config/translations"

import './index.scss'


const Select = (props) => {
    const { ref,  bind, error, displayError, disabled} = useInput(props)
    const {register, deregister} = props 
    
    useLayoutEffect(() => {
        if (register){
            register(props.name, ref)
        }
        return () => {
            if (deregister){
                deregister(props.name)
            }
        }
    }, [])

    // Change to onchange on rest
    useEffect(() => {
        if (props.onRender) {
            props.onRender()
        }
    }, [bind.value])

    return(
        <div className={`input input-select ${props.className || ''} ${error && displayError ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
        <InputLabel {...props} />
        <div className='group' data-label="Input">
        <select 
            id={props.name}
            {...props} 
            {...bind}
            >
            <option value="" selected disabled>{props.placeholder}</option>
            {props.options.map((option,i) => 
                <option {...option} value={option.value}>{option.label}</option>
            )}
        </select>
        <span aria-label="Control" className="icon-control">
            <span className="icon" 
                style={{
                    WebkitMaskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/chevron-updown.svg)',
                    maskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/chevron-updown.svg)',
                    color: 'currentColor'
                }}
            ></span>
        </span>
        </div>
        <InputMessage error={strings[error] || error}  displayError={displayError} />
        <span className='input-message'><p className='messsage'>{props.error && props.displayError ? props.error : props.message || ''}</p></span>
    </div>
    )
}

export default Select;